import { extractData, getHomepage, getSeoKey, Homepage } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import HomePage from "components/homepage/HomePage"
import { GetStaticProps } from "next"
import styled from "styled-components"
import { HEADER_ANIME_D, HEADER_ANIME_M } from "theme/shared"

type HomeStaticProps = {
  homepageData: Homepage
  seo: SeoMetadataWithImage
}

const StyledPageWrapper = styled.div`
  display: flex;
  padding-top: ${HEADER_ANIME_M}px;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};
  overflow: hidden;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: ${HEADER_ANIME_D}px;
  }
`

export const getStaticProps: GetStaticProps<HomeStaticProps> = async () => {
  const data = await getHomepage().then(extractData)
  const seoData = await getSeoKey("homePage")
  const seo = {
    title: seoData.data.body.title,
    description: seoData.data.body.description,
    keywords: seoData.data.body.keywords,
  }
  return {
    props: {
      homepageData: data?.body,
      seo: seo,
    },
    revalidate: 60,
  }
}

const Home = ({ homepageData, seo }: HomeStaticProps) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <StyledPageWrapper>
        <HomePage homepageData={homepageData} />
      </StyledPageWrapper>
    </>
  )
}

export default Home
